import type { ElementType, Key, ReactNode } from "react";
import { Css, type CssProps } from "../css";

export const wrap = (
  jsx: (
    type: ElementType,
    config: unknown,
    maybeKey: Key | undefined,
    ...rest: any[]
  ) => unknown,
) => {
  return (
    type: ElementType,
    config:
      | ({
          key: Key | undefined;
          children: ReactNode;
        } & CssProps)
      | undefined,
    maybeKey: Key,
    ...rest: unknown[]
  ) => {
    if (
      typeof type !== "string" ||
      !config ||
      !(
        config.css ||
        config.__experimental_placeholderCss ||
        config.__experimental_webkitScrollbarCss ||
        config.__experimental_webkitScrollbarCornerCss ||
        config.__experimental_webkitScrollbarButtonCss ||
        config.__experimental_webkitScrollbarThumbCss ||
        config.__experimental_webkitScrollbarThumbHoverCss ||
        config.__experimental_webkitSearchCancelButtonCss ||
        config.__experimental_webkitSearchDecorationCss ||
        config.__experimental_beforeCss ||
        config.__experimental_afterCss
      )
    ) {
      return jsx(type, config, maybeKey, ...rest);
    }

    const {
      css,
      __experimental_placeholderCss,
      __experimental_webkitScrollbarCss,
      __experimental_webkitScrollbarCornerCss,
      __experimental_webkitScrollbarButtonCss,
      __experimental_webkitScrollbarThumbCss,
      __experimental_webkitScrollbarThumbHoverCss,
      __experimental_webkitSearchCancelButtonCss,
      __experimental_webkitSearchDecorationCss,
      __experimental_beforeCss,
      __experimental_afterCss,
      children,
      ...props
    } = config;

    return jsx(
      Css,
      {
        css,
        __experimental_placeholderCss,
        __experimental_webkitScrollbarCss,
        __experimental_webkitScrollbarCornerCss,
        __experimental_webkitScrollbarButtonCss,
        __experimental_webkitScrollbarThumbCss,
        __experimental_webkitScrollbarThumbHoverCss,
        __experimental_webkitSearchCancelButtonCss,
        __experimental_webkitSearchDecorationCss,
        __experimental_beforeCss,
        __experimental_afterCss,
        type,
        props,
        children,
      },
      maybeKey,
      ...rest,
    );
  };
};
